/**
 * Whether an in-progress session belongs to the logged-in user.
 *
 * Prefer matching `session.user_id` to the auth user id. The server's `is_mine` flag is
 * personalized per caller and can stick in a shared React Query cache after a user switch;
 * the id comparison stays correct even when that flag is stale. Fall back to `is_mine` only
 * when `user_id` is missing (older cached shapes).
 */
export function isOwnInProgressSession(session, user) {
  const myId = user?.id ?? user?.userId;
  if (myId != null && session?.user_id != null) {
    return Number(session.user_id) === Number(myId);
  }
  return session?.is_mine === true;
}
